<div class="grid grid-nogutter mb-3">
    <div class="col-12 md:col-6 sm:col-12 sm:mb-2">
        <h1 class="h4 m-0">{{ 'Client Groups' | sentenceCase }}</h1>
        <div class="breadcrumb">
            <p-breadcrumb class="max-w-full" [model]="breadcrumbItems()" />
        </div>
    </div>
    @if (canManage()) {
        <div class="col-12 md:col-6 sm:col-12 flex md:justify-content-end justify-content-between mt-3 md:mt-0 align-items-start sm:align-items-center md:gap-4 gap-0">
            <p-button label="create" [rounded]="true" icon="pi pi-plus" size="large" (onClick)="showCreateDialog()" />
        </div>
    }
</div>
<div class="projects-data">
    <div class="grid grid-nogutter">
        <div class="col-12 p-0">
            <div class="grid grid-nogutter">
                <div class="col-12 md:col-6 xl:col-4 lg:col-6 sm:col-12 p-0">
                    <div class="wrap-left">
                        <div class="grid grid-nogutter">
                            <div class="md:pr-1 sm:pr-0 col-12 md:col-8 sm:col-12">
                                <p-iconField iconPosition="right">
                                    <p-inputIcon styleClass="pi pi-search" />
                                    <input [ngModel]="searchText()" (ngModelChange)="searchText.set($event)" type="text" pInputText
                                        [placeholder]="'Search Client Groups' | sentenceCase" />
                                </p-iconField>
                            </div>
                            <div class="p-0 col-12 md:col-12 sm:col-12">
                                <ul class="chips">
                                    @if (searchText()) {
                                        <li><p-chip [label]="searchText()" (onRemove)="onRemoveSearchChip()" [removable]="true" /></li>
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 md:col-6 xl:col-8 lg:col-6 sm:col-12 p-0 flex md:justify-content-end align-items-start">
                    <div class="switch-w-label pt-2 flex gap-2">
                        <p-inputSwitch [ngModel]="includeInactive()" (ngModelChange)="onIncludeInactiveChange($event)" class="mpl-switch"
                            inputId="includeInactiveGroups" ariaLabel="Show deactivated groups" />
                        <label for="includeInactiveGroups" class="line-height-2">{{ 'Show deactivated groups' | sentenceCase }}</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 p-0">
            <div class="data-table">
                <p-table styleClass="p-datatable-sm p-datatable-sm--normal" [value]="filteredGroups()" dataKey="_id"
                    [tableStyle]="{ 'min-width': '50rem' }" [expandedRowKeys]="expandedRows()"
                    (onRowExpand)="onRowExpand($event)" (onRowCollapse)="onRowCollapse()"
                    [paginator]="true" [rows]="rowsPerPage()" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first} - {last} of {totalRecords}" autoLayout="true" [scrollable]="true">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Name</th>
                            <th>Status</th>
                            <th>{{ 'Created On' | sentenceCase }}</th>
                            @if (helperService.checkResponsive()) {
                                <th alignFrozen="right" pFrozenColumn>
                                    <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                                </th>
                            } @else {
                                <th style="width: 10%">
                                    <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                                </th>
                            }
                            <ng-template #frozenHeader>Actions</ng-template>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-group let-expanded="expanded">
                        <tr>
                            <td><b>{{ group.name }}</b></td>
                            <td>
                                @if (group.isActive) {
                                    <p-tag value="Active" [rounded]="true" class="pillActive" />
                                } @else {
                                    <p-tag value="Deactivated" [rounded]="true" class="pillInactive" />
                                }
                            </td>
                            <td>{{ group.createdAt | date: 'MMM d, y' }}</td>
                            @if (helperService.checkResponsive()) {
                                <td alignFrozen="right" pFrozenColumn>
                                    <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                                </td>
                            } @else {
                                <td>
                                    <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                                </td>
                            }
                            <ng-template #frozenData>
                                <div class="wrap-actions flex align-items-center gap-2">
                                    @if (canManage() && group.isActive) {
                                        <p-button pTooltip="Rename" tooltipPosition="top" [rounded]="true" [text]="true" icon="true"
                                            (onClick)="showRenameDialog(group)">
                                            <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
                                        </p-button>
                                        <p-button pTooltip="Deactivate" tooltipPosition="top" [rounded]="true" [text]="true" icon="true"
                                            (click)="deactivateGroup($event, group)">
                                            <span class="{{helperService.getEnvironmentName()}}-icon icon-block-outlined red"></span>
                                        </p-button>
                                    }
                                    <p-button type="button" [pRowToggler]="group" [text]="true" [rounded]="true" [plain]="true"
                                        [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-up'" class="row-toggler" />
                                </div>
                            </ng-template>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="rowexpansion" let-group>
                        <tr>
                            <td colspan="4" class="p-0">
                                <div class="inner-wrap surface-100 p-0">
                                    @if (canManage() && group.isActive) {
                                        <div class="flex justify-content-end px-3 pt-3 pb-2">
                                            <p-button [label]="'Invite Client User' | sentenceCase" [rounded]="true" [outlined]="true" icon="pi pi-plus"
                                                size="small" (onClick)="showInviteDialog()" />
                                        </div>
                                    }
                                    <p-table styleClass="p-datatable-sm p-datatable-sm--normal" [value]="members()" dataKey="_id"
                                        autoLayout="true" [scrollable]="true">
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th class="pl-40">Name</th>
                                                <th class="pl-40">Email</th>
                                                <th class="pl-40">Phone</th>
                                                <th class="pl-40">Status</th>
                                                @if (helperService.checkResponsive()) {
                                                    <th alignFrozen="right" pFrozenColumn>
                                                        <ng-container *ngTemplateOutlet="memberFrozenHeader"></ng-container>
                                                    </th>
                                                } @else {
                                                    <th style="width: 10%" class="pr-40">
                                                        <ng-container *ngTemplateOutlet="memberFrozenHeader"></ng-container>
                                                    </th>
                                                }
                                                <ng-template #memberFrozenHeader>Actions</ng-template>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-member>
                                            <tr class="table-data">
                                                <td class="pl-40">{{ member.firstName }} {{ member.lastName }}</td>
                                                <td class="pl-40">{{ member.email }}</td>
                                                <td class="pl-40">{{ member.phone ? helperService.formatPhoneString(member.phone) : '' }}</td>
                                                <td class="pl-40">
                                                    @switch (memberState(member)) {
                                                        @case ('active') { <p-tag value="Active" [rounded]="true" class="pillActive" /> }
                                                        @case ('invited') { <p-tag value="Invited" [rounded]="true" /> }
                                                        @default { <p-tag value="Deactivated" [rounded]="true" class="pillInactive" /> }
                                                    }
                                                </td>
                                                @if (helperService.checkResponsive()) {
                                                    <td alignFrozen="right" pFrozenColumn class="pr-40">
                                                        <ng-container *ngTemplateOutlet="memberFrozenData"></ng-container>
                                                    </td>
                                                } @else {
                                                    <td class="pr-40">
                                                        <ng-container *ngTemplateOutlet="memberFrozenData"></ng-container>
                                                    </td>
                                                }
                                                <ng-template #memberFrozenData>
                                                    @if (canManage() && group.isActive) {
                                                        <div class="wrap-actions flex align-items-center gap-2">
                                                            <p-button pTooltip="Edit" tooltipPosition="top" [rounded]="true" [text]="true" icon="true"
                                                                (onClick)="showEditMemberDialog(member)">
                                                                <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
                                                            </p-button>
                                                            @if (memberState(member) === 'invited') {
                                                                <p-button [pTooltip]="'Resend Invite' | sentenceCase" tooltipPosition="top" [rounded]="true" [text]="true"
                                                                    icon="true" (click)="resendInvite($event, member)">
                                                                    <span class="{{helperService.getEnvironmentName()}}-icon icon-send-outlined"></span>
                                                                </p-button>
                                                            }
                                                            @if (memberState(member) === 'active') {
                                                                <p-button [pTooltip]="'Send Password Reset Link' | sentenceCase" tooltipPosition="top" [rounded]="true"
                                                                    [text]="true" icon="true" (click)="sendPasswordReset($event, member)">
                                                                    <span class="{{helperService.getEnvironmentName()}}-icon icon-lock-reset-outlined"></span>
                                                                </p-button>
                                                            }
                                                        </div>
                                                    }
                                                </ng-template>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="emptymessage">
                                            <tr class="table-data">
                                                @if (membersLoading()) {
                                                    <td colspan="5" class="pl-40">
                                                        <span class="flex align-items-center gap-2">
                                                            <i class="pi pi-spin pi-spinner"></i>
                                                            {{ 'Loading client users' | sentenceCase }}
                                                        </span>
                                                    </td>
                                                } @else {
                                                    <td colspan="5" class="pl-40">{{ 'No client users in this group yet.' | sentenceCase }}</td>
                                                }
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="4">{{ 'No client groups found.' | sentenceCase }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</div>

<p-dialog [visible]="dialogVisible()" (visibleChange)="dialogVisible.set($event)" [modal]="true" [breakpoints]="{ '575px': '90vw' }"
    [style]="{ width: '480px' }" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="header">
        <div class="inline-flex align-items-center justify-content-center gap-2">
            <span class="font-bold white-space-nowrap">{{ dialogTitle() }}</span>
        </div>
    </ng-template>
    <div class="grid p-0">
        <div class="col-12 p-2">
            <p-floatLabel>
                <input id="clientGroupName" [ngModel]="groupName()" (ngModelChange)="groupName.set($event)" [maxlength]="groupNameMaxLength()"
                    type="text" pInputText (keydown.enter)="onSubmit()" />
                <label for="clientGroupName">{{ 'Group Name' | sentenceCase }}<span class="required">*</span></label>
            </p-floatLabel>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button label="CANCEL" size="large" [rounded]="true" [outlined]="true" (onClick)="hideDialog()" />
        <p-button styleClass="freshgreen-background" [label]="submitLabel()" size="large" [disabled]="!isGroupNameValid() || saving()"
            [rounded]="true" (onClick)="onSubmit()" />
    </ng-template>
</p-dialog>

<p-dialog [visible]="memberDialogVisible()" (visibleChange)="memberDialogVisible.set($event)" [modal]="true" [breakpoints]="{ '575px': '90vw' }"
    [style]="{ width: '660px' }" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="header">
        <div class="inline-flex align-items-center justify-content-center gap-2">
            <span class="font-bold white-space-nowrap">{{ memberDialogTitle() }}</span>
        </div>
    </ng-template>
    <div class="grid p-0">
        <div class="col-12 lg:col-6 xl:col-6 p-2">
            <p-floatLabel>
                <input id="memberFirstName" [ngModel]="memberFirstName()" (ngModelChange)="memberFirstName.set($event)"
                    [maxlength]="memberNameMaxLength()" type="text" pInputText />
                <label for="memberFirstName">{{ 'First Name' | sentenceCase }}<span class="required">*</span></label>
            </p-floatLabel>
        </div>
        <div class="col-12 lg:col-6 xl:col-6 p-2">
            <p-floatLabel>
                <input id="memberLastName" [ngModel]="memberLastName()" (ngModelChange)="memberLastName.set($event)"
                    [maxlength]="memberNameMaxLength()" type="text" pInputText />
                <label for="memberLastName">{{ 'Last Name' | sentenceCase }}<span class="required">*</span></label>
            </p-floatLabel>
        </div>
        <div class="col-12 lg:col-6 xl:col-6 p-2">
            <p-floatLabel>
                <input id="memberEmail" [ngModel]="memberEmail()" (ngModelChange)="memberEmail.set($event)" [disabled]="isMemberEdit()"
                    type="email" pInputText />
                <label for="memberEmail">Email<span class="required">*</span></label>
            </p-floatLabel>
            @if (!isMemberEdit() && memberEmail() && !isMemberEmailValid()) {
                <div class="p-error">{{ 'Invalid Email.' | sentenceCase }}</div>
            }
        </div>
        <div class="col-12 lg:col-6 xl:col-6 p-2">
            <p-floatLabel>
                <input id="memberPhone" [ngModel]="memberPhone()" (ngModelChange)="onMemberPhoneInput($event)" maxlength="12"
                    placeholder="000-000-0000" type="tel" pInputText />
                <label for="memberPhone">Phone</label>
            </p-floatLabel>
            @if (memberPhone() && !isMemberPhoneValid()) {
                <div class="p-error">{{ 'Invalid phone number.' | sentenceCase }}</div>
            }
        </div>
    </div>
    <ng-template pTemplate="footer">
        @if (isMemberEdit()) {
            <p-button [label]="memberStatusButtonLabel()" size="large" [rounded]="true" [outlined]="true" [disabled]="memberSaving()"
                (onClick)="onMemberStatusChange()" />
        } @else {
            <p-button label="CANCEL" size="large" [rounded]="true" [outlined]="true" (onClick)="hideMemberDialog()" />
        }
        <p-button styleClass="freshgreen-background" [label]="memberSubmitLabel()" size="large"
            [disabled]="!isMemberFormValid() || memberSaving()" [rounded]="true" (onClick)="onMemberSubmit()" />
    </ng-template>
</p-dialog>
